module.exports = __webpack_public_path__ + "static/mobile-mock-web-dee5fe75b01d2c9104bb9327843f02a8.svg";